<template>
  <FormViewBase title="Phone Login">
    <template #header>
      <BtnBack
        :block="$mq | mq({ xs: true, md: false })"
        :to="{ name: EmailLoginRoute }"
        class="mb-4"
        title="Switch to Email Login"
      />
    </template>
    <template #default>
      <transition name="fade" mode="out-in">
        <LoginPhoneForm @validated="validatedPhoneHandler" />
      </transition>
    </template>
    <template #actions>
      <v-card-actions>
        <v-row class="text-center text-h6">
          <v-col class=""
            >Don't have an account yet?
            <router-link exact to="/signup" class="ml-1"
              >Signup Now</router-link
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </template>
  </FormViewBase>
</template>

<script>
import FormViewBase from '@/views/FormViewBase'
import { CustomerRoutes } from '@/constants/RouteNames'

import LoginPhoneForm from '@/components/LoginPhoneForm'
import BtnBack from '@/components/BtnBack'

export default {
  name: 'CustomerLoginPhoneView',
  components: {
    FormViewBase,
    LoginPhoneForm,
    BtnBack,
  },
  data: () => {
    return {
      EmailLoginRoute: CustomerRoutes.LOGIN,
      EmailHintLoginRoute: CustomerRoutes.LOGIN_EMAIL_HINT,
      emailHint: '',
    }
  },
  methods: {
    validatedPhoneHandler(email) {
      this.$router.push({
        name: this.EmailHintLoginRoute,
        params: { emailHint: email },
      })
    }, // validatedPhoneHandler
  },
}
</script>
